import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import store from './store/store';
import { BrowserRouter as Router } from 'react-router-dom';
import 'antd/dist/reset.css';

import AppRoutes from './routes';
import './App.css';
import { photoSyncService } from './services/photoSyncService';

// Инициализация сервиса синхронизации фото
const initializePhotoSync = () => {
  // Функция загрузки фото на сервер через RTK Query
  const uploadPhotoToServer = async (photo) => {
    if (!photo.metadata?.saveId) {
      throw new Error('saveId отсутствует для синхронизации фото');
    }
    // Преобразуем Blob в File для правильной отправки
    const file = new File([photo.blob], photo.fileName, { type: photo.mimeType });
    
    // Используем API из store через dispatch
    const { plantingsApi } = await import('./api/plantingsApi');
    
    const result = await store.dispatch(
      plantingsApi.endpoints.uploadPlantingPhoto.initiate({
        saveId: photo.metadata?.saveId,
        plantingId: photo.plantingId,
        file: file,
        description: photo.metadata?.description,
      })
    );

    if (result.error) {
      // Если 403 - недостаточно прав, прокидываем специальную ошибку
      if (result.error.status === 403) {
        const error = new Error(result.error.data?.message || 'Недостаточно прав для загрузки фото');
        error.isForbidden = true;
        throw error;
      }
      throw new Error(result.error.data?.message || 'Upload failed');
    }

    return result.data?.url || result.data?.photo?.url || '';
  };

  photoSyncService.initialize(uploadPhotoToServer);
};

function AppWithSync() {
  useEffect(() => {
    initializePhotoSync();
    
    return () => {
      photoSyncService.destroy();
    };
  }, []);

  return <AppRoutes />;
}

function App() {
  return (
    <Provider store={store}>
      <Router>
        <AppWithSync />
      </Router>
    </Provider>
  );
}

export default App;
